module.exports = __webpack_public_path__ + "img/building (1).bbdf1b99.svg";